import { TYPES } from 'action-types/auth';

interface IAction {
    readonly type: string;
    readonly payload: any;
    readonly tokenState: string;
}

export interface IAuthState {
    readonly loginPending: boolean;
    readonly signedIn: boolean;
    readonly tokenState:string;
    readonly tokenValid: boolean;
}

export const defaultState: IAuthState = {
    loginPending: false,
    signedIn: false,
    tokenValid: false,
    tokenState: ''
};

export const reducer = (state: IAuthState = defaultState, action: IAction): IAuthState => {
    switch (action.type) {
        case TYPES.LOGIN.PENDING:
            return {
                ...state,
                loginPending: true,
                signedIn: false
            };
        case TYPES.LOGIN.FULFILLED:
            return {
                ...state,
                loginPending: false,
                signedIn: true
            };
        case TYPES.LOGIN.REJECTED:
            return {
                ...state,
                loginPending: false,
                signedIn: false
            };
        case TYPES.TOKEN.PENDING:
            return {
                ...state,
                tokenValid: false
            };
        case TYPES.TOKEN.FULFILLED:
            return {
                ...state,
                tokenValid: true,
                tokenState: action.tokenState
            };
            
        case TYPES.TOKEN.REJECTED:
            return {
                ...state,
                tokenValid:false,
                tokenState: action.tokenState
            };
        default:
            return state;
    }
};
